<template>
    <a class="btn btn-white"
       data-analytics-id="Logout"
       @click.prevent="click">
        <i class="fa-solid fa-arrow-right-from-bracket fa-fw"></i>
        {{ l('NAV.LOGOUT') }}
    </a>
</template>

<script>
import { container } from '@/container';

export default {
    emits: [
        'done',
    ],

    methods: {
        click() {
            container.dialogService
                .confirm('NAV.LOGOUT_CONFIRM')
                .then((confirmed) => {
                    if (confirmed) {
                        container.userService.logout();
                        this.$emit('done');
                    }
                });
        },
    },
};
</script>
